import { useFormikContext } from 'formik';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { AlloyButton, DeleteIcon } from 'cat-ecommerce-alloy';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import styles from '../../../ProductForm.module.scss';
import { DEFAULT_ROW_VALUES } from '@app/components/pages/checkout/shopping-cart/ShoppingCartPage/constants';

const ItemRowDeleteButton = ({ addRow, deleteRow, rowNum, rowRef }) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const { values } = useFormikContext();
  const manipulated =
    values.items[rowNum].itemNumber !== DEFAULT_ROW_VALUES.itemNumber &&
    values.items[rowNum].quantity !== DEFAULT_ROW_VALUES.quantity;
  const numRows = values.items?.length;

  const onDeleteClick = () => {
    if (numRows > 2) {
      rowRef.current.classList.remove(styles['product__form-row-dynamic-add']);
      rowRef.current.classList.add(styles['product__form-row-deleted']);
      setTimeout(async () => {
        deleteRow(rowNum);
      }, 600);
    } else {
      deleteRow(rowNum);
      addRow(rowNum);
    }
  };

  return (
    <AlloyButton
      type="button"
      buttonType="ghost"
      className={cx(
        'h-100 p-0 mx-2 px-1 mt-1 m-md-0 ms-md-1 px-md-2 pb-md-2 pt-md-1',
        'd-inline-flex align-items-baseline',
        styles['product__form-delete-column']
      )}
      onClick={onDeleteClick}
      disabled={numRows <= 2 && !manipulated}
    >
      <DeleteIcon
        className={cx({ 'pt-1': isMD })}
        width={isMD ? 17 : 32}
        height={isMD ? 20 : 38}
      />
    </AlloyButton>
  );
};
ItemRowDeleteButton.propTypes = {
  addRow: PropTypes.func.isRequired,
  deleteRow: PropTypes.func.isRequired,
  errorInfo: PropTypes.shape({
    domain: PropTypes.string,
    path: PropTypes.string
  }),
  rowNum: PropTypes.number.isRequired,
  rowRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
};

export default ItemRowDeleteButton;
